import type { CategoryInfo, ContentItem, TopicInfo } from "@/types/content";

export const categories: CategoryInfo[] = [
  {
    type: "video",
    name: "趣味视频",
    tagline: "精彩趣味视频一网打尽",
    description: "三分钟一个小惊喜，搞笑、治愈、共鸣轮番上阵，随时随地开心一下。",
    icon: "ri-movie-2-line",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20playful%20abstract%20video%20play%20button%20scene%20with%20soft%20warm%20orange%20gradient%20background%20and%20floating%20geometric%20shapes%2C%20minimal%20modern%20illustration%2C%20high%20detail&width=800&height=600&seq=xx-cat-video&orientation=landscape",
  },
  {
    type: "joke",
    name: "搞笑段子",
    tagline: "笑到合不拢嘴的文字现场",
    description: "短小精悍的文字段子，通勤路上、午休时间刷几条，快乐立刻到账。",
    icon: "ri-emotion-laugh-line",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20abstract%20speech%20bubble%20illustration%20with%20warm%20orange%20and%20cream%20tones%20on%20soft%20light%20background%2C%20minimal%20modern%20design%2C%20gentle%20shadows&width=800&height=600&seq=xx-cat-joke&orientation=landscape",
  },
  {
    type: "interview",
    name: "轻松访谈",
    tagline: "和有趣的人聊点有趣的事",
    description: "走进喜剧演员、编剧和普通人的生活，聊聊快乐是怎么被制造出来的。",
    icon: "ri-mic-line",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20podcast%20microphone%20illustration%20with%20soft%20teal%20and%20cream%20background%2C%20minimal%20modern%20flat%20design%2C%20warm%20cozy%20lighting%20feel&width=800&height=600&seq=xx-cat-interview&orientation=landscape",
  },
];

export const topics: TopicInfo[] = [
  {
    id: "spring-joy",
    title: "春日欢乐合集",
    description: "把春天最治愈的十个瞬间打包给你，看完心情像天气一样放晴。",
    cover:
      "https://readdy.ai/api/search-image?query=bright%20spring%20abstract%20background%20with%20soft%20warm%20orange%20and%20light%20yellow%20gradient%2C%20floating%20petals%20and%20gentle%20light%20rays%2C%20minimal%20modern%20illustration%2C%20cheerful%20mood&width=1200&height=800&seq=xx-topic-spring&orientation=landscape",
    contentIds: ["v02", "v06", "i06", "j07", "v04"],
  },
  {
    id: "joke-best",
    title: "爆笑段子精选",
    description: "编辑部票选出的年度高能段子，每一条都能让你笑出鹅叫。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20bold%20orange%20and%20cream%20background%20with%20playful%20laughing%20emoji%20shapes%20and%20confetti%2C%20minimal%20modern%20graphic%20design%2C%20energetic%20mood&width=1200&height=800&seq=xx-topic-joke&orientation=landscape",
    contentIds: ["j01", "j06", "j02", "j04", "v05"],
  },
  {
    id: "worker-relax",
    title: "打工人的解压时刻",
    description: "下班后的三十分钟，留给那些让你会心一笑的职场故事。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20abstract%20evening%20desk%20scene%20illustration%20with%20warm%20lamp%20light%2C%20soft%20teal%20and%20orange%20tones%2C%20minimal%20modern%20style%2C%20relaxing%20mood&width=1200&height=800&seq=xx-topic-worker&orientation=landscape",
    contentIds: ["v01", "v07", "i04", "j03", "v03"],
  },
];

export const contents: ContentItem[] = [
  {
    id: "v01",
    title: "办公室摸鱼图鉴：老板不在的十分钟",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20modern%20office%20desk%20scene%20with%20a%20coffee%20cup%20and%20softly%20glowing%20computer%20screen%2C%20warm%20orange%20accent%20lighting%2C%20minimal%20illustration%2C%20humorous%20relaxed%20vibe&width=800&height=600&seq=xx-c-v01&orientation=landscape",
    summary: "老板前脚刚走，办公室就上演了一场全员演技大赏。这十分钟，谁还不是个影帝？",
    body: "下午三点，会议室的门轻轻合上。\n\n最先有动作的是靠窗那位，鼠标一点，屏幕上瞬间从报表切换成了新番。隔壁的姑娘假装在拉伸，其实耳机已经戴上了。\n\n最稳的是前台小姐姐，她端起茶杯起身走动，完美地完成了全场巡逻。\n\n十分钟后，走廊传来熟悉的脚步声，一切又神奇地恢复了安静。只有那杯还没喝完的咖啡，默默记录着刚才的热闹。",
    duration: 185,
    year: 2024,
    tags: ["职场", "搞笑", "共鸣"],
    views: 128450,
    likes: 8920,
    date: "2024-11-08",
    author: "隔壁工位老王",
  },
  {
    id: "v02",
    title: "当代年轻人周末真实状态",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20weekend%20scene%20with%20soft%20blankets%2C%20snacks%20and%20warm%20afternoon%20sunlight%2C%20minimal%20modern%20illustration%2C%20relaxing%20warm%20orange%20tones&width=800&height=600&seq=xx-c-v02&orientation=landscape",
    summary: "计划表上写满了健身、读书、学英语，实际执行的是：睡到自然醒，然后继续躺。",
    body: "周五晚上：这周末我一定要好好充实自己！\n\n周六早上十点：再躺五分钟。\n\n周六下午三点：点了外卖，顺便看了两集剧。\n\n周日晚上八点：开始焦虑，然后决定下周末一定重新做人。\n\n如此循环，堪称当代年轻人最稳定的作息。",
    duration: 240,
    year: 2024,
    tags: ["生活", "共鸣", "治愈"],
    views: 203110,
    likes: 15230,
    date: "2024-12-01",
    author: "躺平研究所",
  },
  {
    id: "v03",
    title: "妈妈和我关于秋裤的三次谈判",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20home%20hallway%20scene%20with%20folded%20warm%20clothes%20and%20sunlight%20through%20window%2C%20minimal%20illustration%2C%20warm%20cream%20and%20orange%20tones%2C%20family%20warmth%20feeling&width=800&height=600&seq=xx-c-v03&orientation=landscape",
    summary: "第一次我拒绝了，第二次我妥协了，第三次我发现，妈妈是对的。",
    body: "第一回合，气温十二度。妈妈说：穿秋裤。我说：不冷。\n\n第二回合，气温八度。妈妈说：穿秋裤。我穿上了，但偷偷卷到脚踝以上。\n\n第三回合，气温三度，我骑着车在风里发抖，回家第一件事就是翻出那件被我嫌弃了整个秋天的秋裤。\n\n妈妈什么都没说，只是笑了。那一刻我懂了，姜还是老的辣。",
    duration: 156,
    year: 2023,
    tags: ["家庭", "搞笑", "温馨"],
    views: 98760,
    likes: 7450,
    date: "2023-11-20",
    author: "北方的冬天",
  },
  {
    id: "v04",
    title: "干饭人的一天：从早餐到夜宵",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=overhead%20flatlay%20of%20various%20delicious%20meals%20from%20breakfast%20to%20late%20night%20snack%20on%20warm%20wooden%20table%2C%20cozy%20lighting%2C%20minimal%20modern%20food%20photography%20style&width=800&height=600&seq=xx-c-v04&orientation=landscape",
    summary: "记录一个普通干饭人的日常，从早晨的豆浆油条到深夜的一碗面，每顿都值得认真对待。",
    body: "早上七点，豆浆配油条，是一天最踏实的开始。\n\n中午十二点，食堂三楼的盖饭永远是首选，加个蛋是底线。\n\n下午四点，总有那么一刻想要喝奶茶，这叫下午的能量补给。\n\n晚上十一点，加班回家的路上，一碗热汤面治愈了所有疲惫。\n\n认真吃饭，就是认真生活。",
    duration: 320,
    year: 2024,
    tags: ["美食", "日常", "治愈"],
    views: 156780,
    likes: 11200,
    date: "2024-09-15",
    author: "干饭小分队",
  },
  {
    id: "v05",
    title: "学车教练的灵魂拷问合集",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=driving%20school%20car%20interior%20scene%20with%20steering%20wheel%20and%20warm%20daylight%2C%20minimal%20illustration%2C%20humorous%20warm%20orange%20tones%2C%20relatable%20mood&width=800&height=600&seq=xx-c-v05&orientation=landscape",
    summary: "教练的每一句话都让我们怀疑人生，但又句句在理。致敬所有教练的耐心。",
    body: "教练：看到前面那个人没？\n我：看到了。\n教练：撞他。\n我：啊？\n教练：那你还不踩刹车！\n\n还有那句经典：方向盘是拿来转的，不是拿来抱着睡觉的。\n\n以及：你是不是把油门当惊喜了，想踩就踩？\n\n现在想想，没有教练的碎碎念，我可能真的上不了路。",
    duration: 210,
    year: 2023,
    tags: ["职场", "爆笑", "共鸣"],
    views: 176540,
    likes: 13400,
    date: "2023-08-09",
    author: "科目二钉子户",
  },
  {
    id: "v06",
    title: "猫咪是怎么一步步占领沙发的",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20a%20fluffy%20cat%20resting%20on%20a%20soft%20sofa%20and%20warm%20sunlight%2C%20minimal%20modern%20illustration%2C%20warm%20cream%20and%20orange%20tones%2C%20cute%20relaxed%20mood&width=800&height=600&seq=xx-c-v06&orientation=landscape",
    summary: "从小心翼翼地试探，到理直气壮地躺平，全程只用了一个下午。",
    body: "第一步，它先在沙发边缘试探性地坐下。\n\n第二步，它换了个姿势，把自己摊成一张饼。\n\n第三步，它开始打呼噜，顺便占领了最中间的位置。\n\n等你下班回来，沙发上已经没有你的位置了。你只能默默坐到地板上，还得感谢它愿意留一个靠垫给你。",
    duration: 145,
    year: 2024,
    tags: ["萌宠", "治愈", "搞笑"],
    views: 221300,
    likes: 18900,
    date: "2024-06-22",
    author: "吸猫成瘾患者",
  },
  {
    id: "v07",
    title: "打工人通勤路上的迷惑行为",
    type: "video",
    cover:
      "https://readdy.ai/api/search-image?query=subway%20train%20interior%20at%20morning%20rush%20hour%20with%20soft%20window%20light%2C%20minimal%20modern%20illustration%2C%20warm%20neutral%20and%20orange%20tones%2C%20relatable%20urban%20mood&width=800&height=600&seq=xx-c-v07&orientation=landscape",
    summary: "早高峰的地铁上，我们总能遇到各种让人忍俊不禁的瞬间。",
    body: "有人在地铁上背单词，背着背着睡着了。\n\n有人左手早餐右手手机，用下巴刷卡进站。\n\n还有人明明车厢很空，却偏偏要贴着你站。\n\n最神奇的是，每个人都能在完全没睡醒的状态下，精准地找到自己的换乘口。这大概就是打工人的生存本能吧。",
    duration: 198,
    year: 2025,
    tags: ["生活", "共鸣", "搞笑"],
    views: 143220,
    likes: 9980,
    date: "2025-03-11",
    author: "地铁观察员",
  },
  {
    id: "j01",
    title: "周一的我和周五的我",
    type: "joke",
    cover:
      "https://readdy.ai/api/search-image?query=split%20composition%20illustration%20contrasting%20tired%20monday%20mood%20and%20happy%20friday%20mood%2C%20warm%20orange%20and%20cream%20palette%2C%20minimal%20modern%20graphic%20style&width=800&height=600&seq=xx-c-j01&orientation=landscape",
    summary: "同一个我，两种状态，周一像被抽走了灵魂，周五像充了电。",
    body: "周一的早上：闹钟响了七遍，我怀疑它坏了。\n\n周五的下午：还有二十分钟下班，我已经规划好了周末的一百种可能。\n\n周一的我：这周好长啊，看不到头。\n\n周五的我：时间都去哪儿了，怎么又要上班了。\n\n总结：人生就是一场和日历的拉锯战。",
    duration: 0,
    year: 2024,
    tags: ["共鸣", "职场", "自嘲"],
    views: 312400,
    likes: 28700,
    date: "2024-10-14",
    author: "段子手阿茶",
  },
  {
    id: "j02",
    title: "关于减肥，我已经尽力了",
    type: "joke",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20illustration%20of%20a%20salad%20bowl%20and%20a%20slice%20of%20cake%20coexisting%20on%20bright%20table%2C%20warm%20cream%20and%20orange%20tones%2C%20minimal%20modern%20humorous%20style&width=800&height=600&seq=xx-c-j02&orientation=landscape",
    summary: "减肥第一天：水煮菜。减肥第二天：水煮菜配奶茶。减肥第三天：我放弃了。",
    body: "我给自己定了一个小目标：这个月瘦五斤。\n\n第一周，我认真吃沙拉，感觉自己活得像个仙女。\n\n第二周，我在沙拉里加了鸡胸肉，觉得这样才健康。\n\n第三周，我点了炸鸡，告诉自己这是给辛苦一周的奖励。\n\n第四周，我站在秤上，秤发出了疑惑的声音。\n\n没关系，下个月继续。",
    duration: 0,
    year: 2024,
    tags: ["生活", "自嘲", "搞笑"],
    views: 268900,
    likes: 21400,
    date: "2024-07-30",
    author: "干饭小分队",
  },
  {
    id: "j03",
    title: "当代社恐的十大瞬间",
    type: "joke",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20illustration%20of%20a%20person%20hiding%20behind%20a%20smartphone%20in%20a%20social%20setting%2C%20warm%20neutral%20cream%20and%20orange%20palette%2C%20relatable%20humorous%20mood&width=800&height=600&seq=xx-c-j03&orientation=landscape",
    summary: "每一条都精准命中，看完只想说：是谁在偷看我的人生？",
    body: "一，电梯里遇到不太熟的同事，全程盯着楼层数字。\n\n二，点外卖备注：放门口就行，不要敲门。\n\n三，聚会时上厕所，回来发现座位变了，干脆站着。\n\n四，接到陌生电话，等它响完再说。\n\n五，被人夸了一句，脸红到耳根，还说不出一句完整的话。\n\n六到十，请各位自行对照，反正我已经原地社死了。",
    duration: 0,
    year: 2025,
    tags: ["社交", "共鸣", "搞笑"],
    views: 356700,
    likes: 32100,
    date: "2025-04-18",
    author: "社恐本人",
  },
  {
    id: "j04",
    title: "同学聚会上的凡尔赛现场",
    type: "joke",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20restaurant%20table%20gathering%20scene%20illustration%20with%20warm%20lighting%2C%20cream%20and%20orange%20tones%2C%20minimal%20modern%20humorous%20style&width=800&height=600&seq=xx-c-j04&orientation=landscape",
    summary: "饭桌上每个人都在云淡风轻地分享人生，只有我在默默计算账单。",
    body: "同学A：最近换了辆车，就是停车不太方便。\n\n同学B：哎呀别提了，新房子太大，打扫起来累死了。\n\n同学C：我那个项目啊，客户太热情了，天天请吃饭。\n\n我：最近……最近我学会了做番茄炒蛋。\n\n全场安静了一秒，然后大家举杯：这个好，这个实在！\n\n那一刻我发现，会做饭也是一种硬通货。",
    duration: 0,
    year: 2024,
    tags: ["社交", "搞笑", "自嘲"],
    views: 189340,
    likes: 16700,
    date: "2024-08-25",
    author: "段子手阿茶",
  },
  {
    id: "j05",
    title: "我家WiFi和我的爱恨情仇",
    type: "joke",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20illustration%20of%20a%20wifi%20router%20glowing%20with%20signal%20waves%20on%20cozy%20desk%2C%20warm%20orange%20and%20cream%20palette%2C%20humorous%20modern%20style&width=800&height=600&seq=xx-c-j05&orientation=landscape",
    summary: "它在我看视频时卡顿，在我睡觉时满格，这是有预谋的。",
    body: "我家的WiFi非常有个性。\n\n我看剧的时候，它转圈。\n\n我打游戏的时候，它掉线。\n\n但当我准备睡觉、手机放在床头的时候，它信号满格，快得能飞起来。\n\n我一度怀疑它在报复我：谁让你白天不怎么理我。\n\n后来我给它换了个位置，它终于消停了——或者说，它找到了新的方式气我。",
    duration: 0,
    year: 2023,
    tags: ["生活", "搞笑", "吐槽"],
    views: 145600,
    likes: 12300,
    date: "2023-09-12",
    author: "网速受害者",
  },
  {
    id: "j06",
    title: "相亲现场的那些神回复",
    type: "joke",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20cafe%20table%20for%20two%20with%20coffee%20cups%20and%20warm%20window%20light%2C%20minimal%20modern%20illustration%2C%20cream%20and%20orange%20tones%2C%20lighthearted%20mood&width=800&height=600&seq=xx-c-j06&orientation=landscape",
    summary: "有些回答，礼貌中带着杀伤力，温柔里藏着刀。",
    body: "对方问：你有什么爱好？\n我答：躺着，你介意吗？\n对方：不介意，我也喜欢。\n\n对方问：你月薪多少？\n我答：够我躺着就好。\n\n对方问：你对另一半有什么要求？\n我答：别催我做家务，最好还会做饭。\n\n最后对方说：要不我们各回各家，继续躺着吧。\n\n我觉得，这可能是我遇过最合适的人了。",
    duration: 0,
    year: 2024,
    tags: ["社交", "爆笑", "自嘲"],
    views: 234100,
    likes: 20100,
    date: "2024-05-06",
    author: "相亲成长日记",
  },
  {
    id: "j07",
    title: "我妈的微信表情包大赏",
    type: "joke",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20smartphone%20chat%20bubble%20illustration%20filled%20with%20colorful%20emoji%20stickers%2C%20warm%20cream%20and%20orange%20palette%2C%20minimal%20modern%20humorous%20style&width=800&height=600&seq=xx-c-j07&orientation=landscape",
    summary: "她收藏的表情包，每一张都精准地表达了她想说又不方便说的话。",
    body: "我妈的微信里，有一个专属文件夹，叫“好用”。\n\n里面全是那种闪闪发光的、带着莲花和早安问候的表情包。\n\n每次我熬夜，她会发一张「早点休息」的动图，配上一朵会转的花。\n\n每次我没回消息，她会发一个「在吗」的小人，可怜巴巴地看着我。\n\n我嘴上嫌土，但每次看到，心里都是暖的。这就是妈妈式的浪漫吧。",
    duration: 0,
    year: 2025,
    tags: ["家庭", "温馨", "搞笑"],
    views: 201800,
    likes: 19800,
    date: "2025-02-14",
    author: "北方的冬天",
  },
  {
    id: "i01",
    title: "对话喜剧演员：笑点是怎么炼成的",
    type: "interview",
    cover:
      "https://readdy.ai/api/search-image?query=two%20people%20having%20a%20warm%20conversation%20in%20a%20cozy%20bright%20studio%20with%20microphones%2C%20soft%20teal%20and%20warm%20orange%20tones%2C%20minimal%20modern%20illustration&width=800&height=600&seq=xx-c-i01&orientation=landscape",
    summary: "一个能把全场逗笑的人，背后做了多少功课？我们和他聊了聊舞台之外的那些事。",
    body: "问：很多人觉得喜剧演员天生就有幽默细胞，是这样吗？\n\n答：真不是。我小时候其实特别内向，是后来逼着自己上台，一次次被冷场教育出来的。幽默是练出来的，不是天生的。\n\n问：你怎么定义一个好段子？\n\n答：让人笑完之后，心里还能留下一句“好像真是这么回事”。如果只有笑没有共鸣，那只是一次性的。\n\n问：有没有想过放弃？\n\n答：有，很多次。但有一次台下有个观众笑着哭了，我那天晚上就没舍得放弃。\n\n问：给想入行的年轻人的建议？\n\n答：多观察生活，少讲别人的段子。你的生活里，永远藏着别人没有的笑点。",
    duration: 480,
    year: 2024,
    tags: ["幕后", "深度", "喜剧"],
    views: 87600,
    likes: 6900,
    date: "2024-10-02",
    author: "羞羞访谈室",
  },
  {
    id: "i02",
    title: "街头访谈谈：你最近一次大笑是什么时候",
    type: "interview",
    cover:
      "https://readdy.ai/api/search-image?query=street%20interview%20scene%20on%20a%20soft%20sunny%20city%20alley%20with%20passersby%2C%20warm%20cream%20and%20orange%20tones%2C%20minimal%20modern%20illustration%2C%20warm%20friendly%20mood&width=800&height=600&seq=xx-c-i02&orientation=landscape",
    summary: "我们走上街头，问了路人一个问题，结果收到了一堆又好笑又暖心的答案。",
    body: "问：你最近一次大笑是什么时候？\n\n一位外卖小哥：昨天送错了一单，结果那家人特别好，还留我吃了碗面，我们俩都笑到肚子疼。\n\n一位上班族：今天早上地铁没挤上，我就站在站台上笑了一分钟，不笑的话我怕我会哭。\n\n一位大学生：室友半夜说梦话，喊了一句“别抢我的鸡腿”，全宿舍都醒了。\n\n原来快乐这么简单，它就藏在我们每天路过的普通时刻里。",
    duration: 360,
    year: 2024,
    tags: ["街头", "治愈", "生活"],
    views: 132500,
    likes: 11400,
    date: "2024-09-19",
    author: "羞羞访谈室",
  },
  {
    id: "i03",
    title: "专访脱口秀编剧：段子背后的生活",
    type: "interview",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20writer%20desk%20with%20notebooks%20and%20warm%20lamp%20light%20at%20night%2C%20minimal%20modern%20illustration%2C%20warm%20orange%20and%20cream%20tones%2C%20thoughtful%20mood&width=800&height=600&seq=xx-c-i03&orientation=landscape",
    summary: "一个段子从生活到舞台要经过多少次打磨？编剧说，比你想的多得多。",
    body: "问：一个段子通常要改多少遍？\n\n答：短的七八遍，长的二十多遍。有时候一个包袱，为了那个节奏点，我们要读上几十次。\n\n问：灵感枯竭的时候怎么办？\n\n答：去坐地铁，去菜市场，去听别人聊天。生活里全是素材，就看你有没有耳朵。\n\n问：最难的是什么？\n\n答：最难的是保持真诚。观众很聪明，你一敷衍，他们立刻就能感觉到。\n\n问：有什么想对观众说的？\n\n答：如果你笑了，那说明我们没有白熬那些夜。",
    duration: 520,
    year: 2023,
    tags: ["幕后", "深度", "创作"],
    views: 74300,
    likes: 5800,
    date: "2023-12-05",
    author: "羞羞访谈室",
  },
  {
    id: "i04",
    title: "和三位打工人聊聊他们的解压方式",
    type: "interview",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20evening%20scene%20with%20three%20friends%20chatting%20over%20tea%20in%20warm%20room%2C%20minimal%20modern%20illustration%2C%20warm%20orange%20and%20teal%20tones%2C%20comforting%20mood&width=800&height=600&seq=xx-c-i04&orientation=landscape",
    summary: "加班之后你靠什么回血？三个不同职业的人，给出了三种答案。",
    body: "一位设计师：我会把手机关掉，画一张和工作完全无关的画，画得丑也没关系。\n\n一位程序员：我养了两只猫。猫不会催我上线，只会踩我的键盘。这已经是很好的生活了。\n\n一位老师：我每天骑车回家，路上什么都不想，风声一吹，一天的疲惫就散了一半。\n\n问：有没有想过彻底逃离？\n\n三个人都笑了：想啊，但第二天闹钟一响，还是乖乖去上班。因为我们都需要那些能让自己笑出来的理由。",
    duration: 420,
    year: 2025,
    tags: ["职场", "生活", "治愈"],
    views: 98600,
    likes: 8100,
    date: "2025-01-22",
    author: "羞羞访谈室",
  },
  {
    id: "i05",
    title: "对话短视频博主：三分钟如何讲好一个笑话",
    type: "interview",
    cover:
      "https://readdy.ai/api/search-image?query=content%20creator%20video%20setup%20with%20ring%20light%20and%20camera%20in%20bright%20cozy%20room%2C%20minimal%20modern%20illustration%2C%20warm%20cream%20and%20orange%20tones&width=800&height=600&seq=xx-c-i05&orientation=landscape",
    summary: "短视频时代的笑点被压缩到几秒钟，这是考验，也是艺术。",
    body: "问：短视频的搞笑和传统喜剧有什么不一样？\n\n答：节奏完全不一样。观众的手指随时准备划走，你必须在三秒内抓住他，在前五秒让他决定留下来。\n\n问：最难的是什么？\n\n答：把复杂的东西讲简单。一个笑话，你要在几十秒里完成铺垫、转折和爆点，多一秒都嫌多。\n\n问：拍一条视频要多久？\n\n答：有人说我们拍三分钟，其实后面是三个小时。剪辑、配乐、字幕，一个都不能少。\n\n问：观众为什么爱看轻松的内容？\n\n答：因为生活已经够累了，大家需要一点能笑出来的理由。这就是我们存在的意义。",
    duration: 390,
    year: 2024,
    tags: ["创作", "幕后", "短视频"],
    views: 110200,
    likes: 9300,
    date: "2024-11-27",
    author: "羞羞访谈室",
  },
  {
    id: "i06",
    title: "轻松访谈：快乐可以练习吗",
    type: "interview",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20cozy%20interview%20corner%20with%20plants%20and%20soft%20daylight%2C%20minimal%20modern%20illustration%2C%20warm%20teal%20and%20cream%20tones%2C%20peaceful%20mood&width=800&height=600&seq=xx-c-i06&orientation=landscape",
    summary: "如果快乐是一种能力，那它能不能像肌肉一样被锻炼出来？我们找了答案。",
    body: "问：快乐是可以练习的吗？\n\n答：可以，而且非常值得练习。心理学里有个方法叫「三件好事」，每天睡前写下今天让你开心的三件小事，坚持一段时间，你会发现你更容易注意到生活中的好。\n\n问：为什么很多人觉得快乐越来越难？\n\n答：因为我们习惯了把注意力放在问题上，久了就以为生活只有问题。其实快乐一直在，只是我们没看它。\n\n问：给普通人的一个小建议？\n\n答：每天给自己三分钟，认真笑一次。可以是看个段子，也可以是想起某个好笑的瞬间。快乐会积攒的，你信我。",
    duration: 450,
    year: 2025,
    tags: ["心理", "治愈", "生活"],
    views: 121400,
    likes: 10700,
    date: "2025-05-09",
    author: "羞羞访谈室",
  },
];